var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Paper, Popover as PopoverMUI, Typography, } from '@mui/material';
import { Delimiter } from '../delimiter';
import { Close } from '@otp/icons';
export const Popover = (_a) => {
    var { open, onClose, title, children } = _a, props = __rest(_a, ["open", "onClose", "title", "children"]);
    return (_jsxs(PopoverMUI, Object.assign({ sx: { maxWidth: 1024 }, open: open, onClose: onClose }, props, { children: [title && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "subtitle1", sx: { margin: 1, marginRight: 8 }, children: title }), _jsx(Delimiter, {}), _jsx(IconButton, { "aria-label": "close", onClick: onClose, sx: {
                            position: 'absolute',
                            right: 8,
                            top: 15,
                            color: (theme) => theme.palette.grey[600],
                        }, children: _jsx(Close, {}) })] })), _jsx(Paper, { sx: { margin: 1 }, elevation: 0, children: children })] })));
};
